import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';

import ZitatBlockEdit from './my-blocks/zitat-block/Edit';
import ZitatBlockView from './my-blocks/zitat-block/View';
import ZitatBlockIcon from '@plone/volto/icons/annotation.svg';

import TeaserEdit from './my-blocks/teaser-block/Edit';
import TeaserView from './my-blocks/teaser-block/View';
import TeaserBlockIcon from '@plone/volto/icons/column.svg';

import KontakteEdit from './my-blocks/kontakte-block/Edit';
import KontakteView from './my-blocks/kontakte-block/View';
import KontakteIcon from '@plone/volto/icons/group.svg';

// Slider
import SliderEdit from './my-blocks/custom-slider/components/Edit';
import SliderView from './my-blocks/custom-slider/components/View';
import sliderSVG from '@plone/volto/icons/slider.svg';
import './my-blocks/custom-slider/theme/main.less';

import DienstleistungsListing from './customizations/volto/components/manage/Blocks/Listing/DienstleistungsListing';

function applyConfig(config: ConfigType) {
  installSettings(config);

  config.blocks.blocksConfig.zitat_block = {
    id: 'zitat_block',
    title: 'Zitat Block',
    edit: ZitatBlockEdit,
    view: ZitatBlockView,
    icon: ZitatBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.teaser_block = {
    id: 'teaser_block',
    title: 'Teaser Block',
    edit: TeaserEdit,
    view: TeaserView,
    icon: TeaserBlockIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.kontakte_block = {
    id: 'kontakte_block',
    title: 'Kontakte Block',
    edit: KontakteEdit,
    view: KontakteView,
    icon: KontakteIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Slider
  config.blocks.blocksConfig.slider = {
    id: 'slider',
    title: 'SliderNoLink',
    group: 'common',
    icon: sliderSVG,
    view: SliderView,
    edit: SliderEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    referenceContainerQuery: '.container .header',
  };

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'DienstleistungsListing',
      title: 'Dienstleistungen Listing',
      template: DienstleistungsListing,
      fullobjects: true,
    },
  ];

  return config;
}

export default applyConfig;
